import { memo } from 'react';
import { useSelector } from 'react-redux';

import { useShortIdContext } from '@air/provider-short-id';

import { ConnectedPDFSearch } from '~/components/AssetModalV2/Visualizer/PDFVisualizer/PDFSearch/ConnectedPDFSearch';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { AssetModalContentHeader } from '~/components/v2/components/asset-modal/desktop/content/header/AssetModalContentHeader';
import { AssetModalContentHeaderColumn } from '~/components/v2/components/asset-modal/desktop/content/header/AssetModalContentHeaderColumn';
import { AssetModalContentHeaderCommentsPanelButton } from '~/components/v2/components/asset-modal/desktop/content/header/AssetModalContentHeaderCommentsPanelButton';
import { AssetModalContentHeaderInfoPanelButton } from '~/components/v2/components/asset-modal/desktop/content/header/AssetModalContentHeaderInfoPanelButton';
import { PublicAssetModalContentHeaderCustomFields } from '~/components/v2/components/asset-modal/desktop/content/header/PublicAssetModalContentHeaderCustomFields';
import { centralizedClipIsPDFTypeSelector } from '~/store/centralizedClip/selectors';
import { canSeeAssetCustomFields, canViewAssetDiscussions } from '~/utils/permissions/assetPermissions';

export const PublicAssetModalContentHeader = memo(() => {
  const { permissions } = usePublicPermissions();
  const { presentationSettings } = useShortIdContext();
  const isPDF = useSelector(centralizedClipIsPDFTypeSelector);

  const canViewCustomFields = canSeeAssetCustomFields(permissions);
  const canViewComments = canViewAssetDiscussions(permissions);
  const hideInfoTab = presentationSettings?.hideInfoTab === true;

  return (
    <AssetModalContentHeader>
      <AssetModalContentHeaderColumn side="left">{isPDF && <ConnectedPDFSearch />}</AssetModalContentHeaderColumn>

      <AssetModalContentHeaderColumn side="center" />

      <AssetModalContentHeaderColumn side="right">
        {!hideInfoTab && canViewCustomFields && <PublicAssetModalContentHeaderCustomFields />}
        {!hideInfoTab && <AssetModalContentHeaderInfoPanelButton />}
        {canViewComments && <AssetModalContentHeaderCommentsPanelButton />}
      </AssetModalContentHeaderColumn>
    </AssetModalContentHeader>
  );
});

PublicAssetModalContentHeader.displayName = 'PublicAssetModalContentHeader';
